<!--
 * @Autor: xx
 * @Version: 1.0
 * @Date: 2020-05-20 14:39:10
 * @LastEditors: xx
 * @Description: 
 * @LastEditTime: 2021-04-25 15:50:05
-->
<template>
  <Layout id="app">
    <Header class="sys-header" v-show="sys.isLogin">
      <pi-header :menuId="menuId" :isLogin="sys.isLogin"></pi-header>
    </Header>
    <Layout class="app-layout">
      <Sider
        hide-trigger
        :class="isCollapse ? 'sys-nav' : 'sys-nav-small'"
        v-show="sys.isLogin"
      >
        <pi-menu
          :menuId="menuId"
          :isCollapse="isCollapse"
          @collapse="isCollapse = !isCollapse"
        ></pi-menu>
      </Sider>
      <Content>
        <sys-content-header v-show="sys.isLogin"></sys-content-header>
        <div class="router-content" :class="{ 'login-p': !sys.isLogin }">
          <keep-alive :include="sys.keepAliveList">
            <router-view />
          </keep-alive>
          <Spin size="large" fix v-if="sys.pageLoading"></Spin>
        </div>
        <Footer class="sys-footer"
          ><a :href="$config.footerUrl" target="_blank">{{
            sys.footText
          }}</a></Footer
        >
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import Header from "./components/header/hearer";
import Menu from "./components/menu/menu";
import SysContentHeader from "./components/sys-content-header/sys-content-header";
// import divScroll from "./components/div-scroll/div-scroll.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "app",
  data() {
    return {
      menuId: "",
      isCollapse: false
    };
  },
  methods: {
    thatUrl(to) {
      if (to) {
        if (to.matched[0]) {
          const name = to.matched[0].components.default.name;
          const routerTag = {
            url: to.path,
            name: to.name,
            componentsName: name,
            englishName:
              to.meta && to.meta.menuData && to.meta.menuData.englishName
                ? to.meta.menuData.englishName
                : ""
          };
          if (routerTag.url !== "/login") {
            this.SET_GOROUTER(routerTag);
          }
        }
        if (to.meta.menuData) {
          this.menuId = to.meta.menuData.menuIndex;
        }
        this.SET_TODATE(to);
      }
    },
    ...mapMutations(["SET_GOROUTER", "SET_TODATE"])
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "thatUrl"
  },
  mounted() {
    this.thatUrl(this.$route);
  },
  components: {
    "pi-header": Header,
    "pi-menu": Menu,
    "sys-content-header": SysContentHeader
    // "pi-div-scroll": divScroll
  },
  computed: {
    ...mapState(["sys"])
  }
};
</script>

<style lang="less">
#app {
  .router-content {
    flex: 1;
    margin: 0 0.06rem;
    position: relative;
    background: #fff;
    flex: 1;
    overflow: hidden;
    // overflow-y: auto;
  }
  .router-content.login-p {
    margin: 0;
  }
  .ivu-layout-content {
    background: #eef0f5;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .app-layout {
    overflow: hidden;
  }
}
.ivu-layout-header.sys-header {
  background: #00b2b3 !important;
  position: relative;
  height: 0.75rem !important;
  z-index: 5;
  padding: 0;
}
.ivu-layout-sider {
  transition: all 0.1s ease-in-out;
}
.ivu-layout-sider.sys-nav {
  width: 2rem !important;
  min-width: 2rem !important;
  max-width: 2rem !important;
  flex: 0 0 2rem !important;
  background: #0077ce !important;
  position: relative;
}
.ivu-layout-sider.sys-nav-small {
  width: 0.5rem !important;
  min-width: 0.5rem !important;
  max-width: 0.5rem !important;
  flex: 0 0 0.5rem !important;
  background: #fff !important;
  position: relative;
  box-shadow: 1px 1px 2px 0px rgba(153, 153, 153, 0.5);
}
.ivu-layout-footer.sys-footer {
  padding: 0;
  text-align: center;
  color: #999999;
  font-size: 0.12rem;
  height: 0.16rem;
  line-height: 0.16rem;
}
.menu-small-width {
  width: 0.5rem;
}
</style>
